import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {NavLink} from "react-router-dom";
import Popup from '../../index';
import Button from '../../../button';

/**
 * @return {string}
 */
function SuspiciousDeletedContactsPopup () {

	const [closePopup, setClosePopup] = useState(false);

	const { t } = useTranslation();

	const handleClosePopup = () => {
		setClosePopup(true)
	};

	if(closePopup){
		return '';
	}

	return (
		<Popup className="p-4" onClose={closePopup}>
			<h2>{t('suspiciousDeletedContactsPopupTitle')}</h2>
			<p>{t('suspiciousDeletedContactsPopupText')}</p>
			<div className="text-center">
				<NavLink to={'/review-deleted-contacts'} className="btn btn-primary mt-3 mr-3">{t('reviewBtn')}</NavLink>
				<Button onClick={ handleClosePopup } className="btn-secondary mt-3 ml-3">{t('skipBtn')}</Button>
			</div>
		</Popup>
	)
}

export default SuspiciousDeletedContactsPopup;
